module.exports = __webpack_public_path__ + "static/BasisGrotesquePro-Light-911af70bd0b9799c841b7e329331038f.woff2";